import FileWithContext from '../../models/file_with_context'
import InvalidEnum from '../invalid_enum'

class InvalidDocumentType extends InvalidEnum {
  constructor(value) {
    super(value, 'document_type', Object.values(FileWithContext.DOCUMENT_TYPE))
  }
}

export default InvalidDocumentType
